import React from 'react';

import { schemas } from '@/network/client';
import { cn } from '@/utils/styles.utils';

import { StaticContentImage } from '../StaticContentImage';
import { StaticContentText } from '../StaticContentText';

interface Props {
  data: schemas['DescriptionField'];
  side?: 'left' | 'right';
}

export const StaticContentItem = (props: Props) => {
  const { data, side } = props;
  const { content, type } = data;

  if (!content) {
    return null;
  }

  const className = cn('[&_img]:rounded-lg', {
    'laptop:mr-3': side === 'left',
    'laptop:ml-3': side === 'right',
  });

  if (type === 'IMAGE') {
    return (
      <div className={className}>
        <StaticContentImage url={content} />
      </div>
    );
  }
  if (type === 'TEXT') {
    return (
      <div className={className}>
        <StaticContentText content={content} side={side} />
      </div>
    );
  }
  return null;
};
